/* eslint-disable */
export const users = state => {
  // console.log('usergetter');
  return state.users;
};
export const media = state => {
  // console.log('mediagetter');
  return state.media;
};
